import { authLogout } from "../../../store/actions/authActions";
import { clearContent } from "../../../store/actions/contentActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";
import { getAllContent } from "./getAllContent";

export const createContent = (userData, bearerAuth, formFunction) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    API.post(`/api/portal/contents`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .send(userData)
      .ok(res => res.status === 201 || res.status === 401)
      .then((response) => {
        if (response.status === 201) {
          dispatch(clearMessage)
          dispatch(getAllContent(bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully created.'
          }))
          formFunction()
        } else if (response.status === 401) {
          dispatch(clearContent);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Create Content Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}